<template>
	<div class="page" style="background-image: url(./images/form_bg.png); background-size: cover; overflow: auto;">
		<div v-if="!stuForm.exam_num" style="padding: 15px;">
			<van-cell-group>

				<div style="text-align: center; background-color: #fff; padding: 20px;">退档申请</div>
				<div style="height: 50px;"></div>
				<!-- 	<van-field v-model="stuForm.stu_name" label="学生姓名" placeholder="请输入姓名" /> -->
				<van-field v-model="exam_num" label="准考证号" placeholder="请输入中考准考证号" />
				<div style="height: 50px;"></div>
				<div class="submitBtn flexAround">
					<div class="btn" @click="onSearch" style="width: 40%;">查询</div>
				</div>
				<div style="height: 50px;"></div>
			</van-cell-group>

		</div>
		<van-cell-group v-else>
			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>报名状态
			</div>
			<div style="padding: 20px; font-size: 14px; position: relative;" @click="goBaoming">
				<div style="font-weight: bold;">
					我的报名 <span v-if="stuForm.status == -1" style="color: orangered;">点击修改报名信息</span>
				</div>
				<div style="padding-top: 10px; color: #888;">
					提交时间：{{ stuForm.cdate }}
				</div>

				<div style="position: absolute; top: 10px; right: 30px; width: 60px;">
					<img v-if="stuForm.status == 0" src="//aiwx.org.cn/static/icon/static/sp_normal.png"
						style="width: 100%;" />
					<img v-if="stuForm.status == 1||stuForm.status == 2" src="//aiwx.org.cn/static/icon/static/sp_over.png"
						style="width: 100%;"/>
					<img v-if="stuForm.status > 2" :src="'./images/luqu.png'" style="width: 100%;"/>
					<img v-if="stuForm.status == -2" :src="'./images/tuidang.png'" style="width: 100%;"/>
					<img v-if="stuForm.status == -1" src="//aiwx.org.cn/static/icon/static/sp_fail.png"
						style="width: 100%;"/>

				</div>
				<div style="font-size: 12px; color: orangered;" v-if="stuForm.status == -1">
					{{ stuForm.sp_word }}
				</div>

			</div>

			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>报名信息
			</div>

			<van-field readonly v-model="stuForm.stu_name" label="考生姓名" label-width="110px" />

			<van-field readonly v-model="stuForm.exam_num" label="考试证号" label-width="110px" />
			<van-field readonly v-model="stuForm.phone" label="手机号" label-width="110px" />
			<van-field readonly :value="stuForm.identity_card" label="身份证号" label-width="110px" />
			<van-field readonly v-model="stuForm.major.title" label="报考专业名称" label-width="110px" />
			<van-field readonly v-model="stuForm.major.item_desc" label="学制" label-width="110px" />

			<div style="background-color: #f7f8fc; padding: 10px; font-size: 12px; font-weight: bold;">
				<span class="rowlabel"></span>退档申请
			</div>
			<van-field required :readonly="td_id > 0 && tdstatus != -1" v-model="reason" label="退档申请原因"
				label-width="110px" placeholder="请输入退档申请原因" />
			<van-field readonly v-model="reason" label="退档状态" label-width="110px">
				<template #input>
					<span v-if="tdstatus === ''">未申请</span>
					<span v-else-if="tdstatus === 0" style="color:lightblue">已提交待审批</span>
					<span v-else-if="tdstatus === 1" style="color:lightgreen">审批通过</span>
					<span v-else-if="tdstatus === -1" style="color:brown">审批拒绝</span>
				</template>
			</van-field>
			<van-field readonly v-if="sp_word" v-model="sp_word" label="审批结果" label-width="110px" />
			<div style="height: 50px; color:orangered;font-size: 12px; text-align: center;">
				退档需要将录取通知书归还至学校招生办公室
			</div>
			<div class="submitBtn flexCenter" v-if="td_id == 0 || tdstatus == -1">
				<div class="btn flexCenter" v-if="stuForm.status==-2||stuForm.status==3" @click="saveStu">提交申请</div>
			</div>
			<div style="height: 50px;">

			</div>
		</van-cell-group>


	</div>
</template>

<script>
import {
	Dialog,
	Toast,
	Uploader
} from 'vant';
export default {
	data() {
		return {
			exam_num:"",
			stuForm: {
				ly_type: "",
				stu_name: "",
				archive: "",
				identity_card: "",
				phone: "",
				gender: "",
				exam_score: "",
				graduate_sch_city: "",
				graduate_schid: -1,
				graduate_schname: "",
				graduate_schname2: "",
				graduate_dist_code: "",
				major_id: "",
				major_id2: '',
				major_id3: '',
				major_name: "",
				major_name2: "",
				major_name3: "",
				volunteer: '',
				volunteerTxt: "",
				oldname: '',
				exam_num: '',
				remark: "",
				jhr1name: "",
				jhr1phone: "",
				jhr2name: "",
				jhr2phone: "",
				minzu: "",
				zzmm: "",
				jiguan: "",
				hkszd: "",
				hkszdpcs: "",
				hkxz: "",
				jzdtype: "",
				jtzz: "",


			},
			reason: "",
			tdstatus: "",
			sp_word: "",
			td_id: 0


		}
	},
	mounted() {
		$(".page").height($(window).height())
		document.title = "退档申请"
		this.pmid = this.$route.query.pmid
		this.openid = this.$route.query.openid
		if (!this.openid) {
			Dialog.alert({
				title: '网络错误',
				message: '未获取到微信授权用户信息，请重新扫码！',
				theme: 'round-button',
			}).then(() => {
				// on close
			});
		} else {
			window.pmid = this.pmid
			this.getStudents()

		}





	},
	methods: {
		goBaoming() {
			if (this.stuForm.status == -1) {
				this.$router.push("/bk?pmid=" + this.pmid + "&openid=" + this
					.openid)
			}
		},
		getStudents() {

			this.$http.post("/api/app_stuinfo", {
				pmid: this.pmid,
				openid: this.openid
			}).then(res => {
				if (res.data) {


					res.data.otherjson = JSON.parse(res.data.otherjson)
					this.stuForm = res.data
					this.getTuidang()

				} else {

				}



			})
		},
		onSearch() {
			//alert("未到开放查询时间")

			if (!this.exam_num) {
				Toast('请输入准考证号');
			} else {
				this.getStudentsByExamNum()



			}
		},
		getStudentsByExamNum() {

			this.$http.post("/api/app_stuinfo", {
				pmid: this.pmid,
				exam_num: this.exam_num
			}).then(res => {
				if (res.data) {


					this.stuForm = res.data
					this.getTuidang()
				} else {

					this.$$confirm({
						msg: "未找到录取信息", okcb: e => {

						}
					})


				}

			})
		},
		getTuidang() {
			this.$http.post("/api/get_tuidang", {
				stu_id: this.stuForm.stu_id
			}).then(res => {
				if (res.data) {
					this.td_id = res.data.id;
					this.reason = res.data.reason;

					this.tdstatus = res.data.sp_status;
					this.sp_word = res.data.sp_word;
				}
			})
		},
		saveStu() {
			if (!this.reason) {
				this.$$alert("请输入退档原因！")
				return
			}

			this.$$confirm({
				msg: "确定提交退档申请？退档需要将录取通知书归还至学生招生办公室！", okcb: e => {
					this.$http.post("/api/save_tuidang", {
						id: this.td_id,
						stu_id: this.stuForm.stu_id,
						reason: this.reason,
						pmid: this.pmid
					}).then(res => {
						if (res.data) {
							this.td_id = res.data.id;
							this.tdstatus = 0
							setTimeout(() => {
								this.$$alert("退档申请已提交")

							}, 300)
						}
					})
				}
			})


		}

	},
}
</script>
<style type="text/css" scoped="scoped">
.rowlabel {
	display: inline-block;
	width: 6px;
	border-radius: 3px;
	height: 14px;
	float: left;
	background: #1283ff;
	vertical-align: middle;
	transform: translateY(2px);
	margin-right: 5px;
}

.submitBtn {
	margin-top: 2vh;
	margin-bottom: 50px;


}

.btn {
	display: inline-block;
	padding: 1.4vh 8%;
	background-color: #00CFDC;
	color: #fff;
	font-size: 15px;
	border-radius: 5vw;
	width: 50%;
	text-align: center;
}

.btn:active {

	background-color: #007AFF;

}
</style>
